import { connect } from 'react-redux';
import { setSidePanelWidth } from 'actions/sidePanel';

import SidePanel from './SidePanel';

export const mapStateToProps = state => ({
  content: state.sidePanel.content,
  containerClassName: state.sidePanel.containerClassName,
  isOpen: state.sidePanel.isOpen,
  sidePanelWidth: state.sidePanel.panelWidth,
});

export const mapDispatchToProps = {
  setSidePanelWidth,
};
export default connect(mapStateToProps, mapDispatchToProps)(SidePanel);
